module.exports = __webpack_public_path__ + "static/media/cedula_frente.f7ee5cc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/cedula_frente.jpg
// module id = 348
// module chunks = 0